import { Directive, ElementRef, Input, Renderer2 } from '@angular/core';

const text = `block w-full rounded-md border border-gray-400 py-2 pl-3 text-gray-900 shadow-sm  ring-inset  placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm sm:leading-6`;
const label = `block text-sm font-medium leading-6 text-gray-900`;
const select =
	'select-control flex flex-grow  w-full max-w-full rounded-md border border-gray-400 pt-2.5 pb-1.5 pl-3 pr-16 text-gray-900  ring-inset  focus:ring-2 focus:ring-gray-400 text-sm sm:leading-6';

const phone = `block w-full rounded-md border border-gray-400 pb-0.5 pl-0 text-gray-900 shadow-sm  ring-inset placeholder:text-gray-400 focus:ring-2 focus:ring-inset focus:ring-blue-600 text-sm sm:leading-6`;

type ControlType = 'text' | 'label' | 'select' | 'phone';

const controlTypes = {
	text,
	label,
	select,
	phone,
};

@Directive({
	selector: '[vqControl]',
})
export class FormControlDirective {
	private className: ControlType = 'text';
	@Input() set vqControl(value: ControlType) {
		this.className = value ? value : this.className;
	}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	constructor(
		private el: ElementRef,
		private readonly renderer: Renderer2
	) {}
	/*
	 **-------------------------------------------------------------------------------------
	 ** METHOD NAME -
	 **-------------------------------------------------------------------------------------
	 */
	ngOnInit() {
		this.el.nativeElement.className = `${controlTypes[this.className]} ${this.el.nativeElement.className} `;
	}
}
